import { Admin, AdminStatus } from "@/types";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import { FC, useState } from "react";
import { sanitizeFieldRestProps, useRecordContext } from "react-admin";
import { useSetAdminStatus } from "../../queries";
import { ActionProps } from "./action-field.types";

const ActionField: FC<ActionProps> = (props) => {
  const [anchorEl, setAnchorEl] = useState<EventTarget & HTMLButtonElement>();

  const user = useRecordContext<Admin>();
  const { setAdminStatus } = useSetAdminStatus({
    closeMenu: () => setAnchorEl(undefined),
  });

  if (!user) return null;

  const isAdminActive = user.status === AdminStatus.ACTIVE;

  return (
    <Stack
      {...sanitizeFieldRestProps(props)}
      onClick={(event: { stopPropagation: () => void }) =>
        event.stopPropagation()
      }
    >
      <IconButton
        style={{ justifyContent: "flex-start" }}
        onClick={({ currentTarget }) => setAnchorEl(currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(undefined)}
      >
        {!isAdminActive && (
          <MenuItem
            onClick={() =>
              setAdminStatus({
                adminId: user.id,
                status: AdminStatus.ACTIVE,
              })
            }
          >
            <ListItemIcon>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText primary="Activate" />
          </MenuItem>
        )}

        {isAdminActive && (
          <MenuItem
            onClick={() =>
              setAdminStatus({ adminId: user.id, status: AdminStatus.INACTIVE })
            }
          >
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            <ListItemText primary="Deactivate" />
          </MenuItem>
        )}
      </Menu>
    </Stack>
  );
};

export { ActionField };
